import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'parent-guardian',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './parent-guardian.component.html',
  styleUrl: './parent-guardian.component.css'
})
export class ParentGuardianComponent implements OnInit, OnChanges {

  @Input() rmsPlanChecklistData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  yesNo = EYesNo;
  parentGuardianForm: FormGroup = new FormGroup([]);

  options = [
    'No parent/guardian follow-up required.',
    'Obtain or maintain permission to share information with community partners such as counselors and therapists.',
    'Review community-based resources and interventions with parents or caretakers',
    'Other agreements made'
  ]

  constructor(
    // private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['rmsPlanChecklistData'] && changes['rmsPlanChecklistData'].currentValue) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    let group: any = {};
    
    // this.checkList.forEach(item => {

    //   group[item.formControlName] = new FormControl(this.rmsPlanChecklistData?.[item.formControlName] || Number(this.yesNo.No));
    //   group[item.notes] = new FormControl(this.rmsPlanChecklistData?.[item.notes] || '');
    //   if (item.formControlName === 'increased_contact') {
    //     group['increased_contact_check_in'] = new FormControl(this.rmsPlanChecklistData?.increased_contact_check_in || '');
    //   }
    // });
    group['parent_follow_up'] = new FormControl(this.rmsPlanChecklistData?.parent_follow_up || this.options[0], Validators.required);
    group['parent_follow_up_notes'] = new FormControl(this.rmsPlanChecklistData?.parent_follow_up_notes || '');
    group['parent_follow_up_roar'] = new FormControl(String(this.rmsPlanChecklistData?.parent_follow_up_roar) || this.yesNo.No, Validators.required);
    this.parentGuardianForm = new FormGroup(group);

    this.setupFormChangeHandlers();
  }

  private setupFormChangeHandlers(): void {
    if (this.parentGuardianForm.get('parent_follow_up')) {
      this.parentGuardianForm.get('parent_follow_up')?.valueChanges.subscribe((value) => {
        const notesControl = this.parentGuardianForm.get('parent_follow_up_notes');
        if (value !== this.options[0]) {
          notesControl?.setValidators(Validators.required);
        } else {
          notesControl?.clearValidators();
          notesControl?.setValue(''); // Clear the value if it's not 'No parent/guardian follow-up required.'
        }
        notesControl?.updateValueAndValidity(); // Trigger validation update
      });
    }
  }

  saveParentGuardian(): void {
    if (this.parentGuardianForm.valid) {
      this.onSaveSection5.emit(this.parentGuardianForm.value);
    }
  }

}
